import { Component, Input } from '@angular/core';

// A white card section: heading, optional count badge and header actions on one row, content below
// at full width. Use for sections whose content needs the whole dialog width (e.g. grids).
// Project header buttons with the `sectionActions` attribute; everything else is the body.
@Component({
    selector: 'app-card-section',
    templateUrl: './card-section.component.html',
    styleUrl: './card-section.component.scss'
})
export class CardSectionComponent {
  @Input({ required: true }) heading = '';
  @Input() badge = '';
}
